import {
  PixlModelsResponse,
  PostApiPixlModelsImagesBody,
} from '@spo/types';
import { apiBff } from '.';

export const getModelsImages = async (
  postApiPixlModelsImagesBody: PostApiPixlModelsImagesBody,
): Promise<PixlModelsResponse> =>
  apiBff.callBFF('POST', 'pixl/models_images', postApiPixlModelsImagesBody);

